import React from 'react';
import styled from 'styled-components';
import {
  Plan,
  INDIVIDUAL_PLAN,
  ENTERPRISE_PLAN
} from '../../../components/Plans';
import DownloadButton from '../../../containers/Buttons/DownloadButton';
import TryItButton from '../../../containers/Buttons/TryItButton';
import TalkToSalesButton from '../../../containers/Buttons/TalkToSalesButton';
import { isDesktop } from '../../../utils';

const PlansContainer = styled.div`
   width: 100%;
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: center;
   flex-wrap: wrap;
`;

const individualButton = isDesktop()
  ? <DownloadButton text="DOWNLOAD"/>
  : <TryItButton/>;

class Pricing extends React.Component {
  render() {
    return (
      <PlansContainer>
        <Plan plan={INDIVIDUAL_PLAN} button={individualButton}/>
        <Plan plan={ENTERPRISE_PLAN} button={<TalkToSalesButton/>}/>
      </PlansContainer>
    )
  }
}

export default Pricing;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/Pricing/index.js